import { Proceed } from "./proceed";

export class PhoneIssue {

  constructor(
    private _key: string,
    private _name: string = null,
    private _code: string = null,
    private _brand: string = null,
    private _model: string = null,
    private _priority: number = null,
    private _finalCustomerPrice: number = null,
    private _finalCustomerPriceVat: number = null,
    private _proceeds: Proceed,
    //private _kaskoPriceVat: number = 0,
  ) { }

  get key(): string {
    return this._key;
  }

  get name(): string {
    return this._name;
  }

  get code(): string {
    return this._code;
  }

  get brand(): string {
    return this._brand;
  }

  get model(): string {
    return this._model;
  }

  get priority(): number {
    return this._priority;
  }


  get finalCustomerPrice(): number {
    return this._finalCustomerPrice;
  }

  get finalCustomerPriceVat(): number {
    return this._finalCustomerPriceVat;
  }

  get proceeds(): Proceed {
    return this._proceeds;
  }

  /*
  get kaskoPriceVat(): number {
    return this._kaskoPriceVat;
  }
  */

}



// WEBPACK FOOTER //
// ./src/app/core/model/phone-issue.ts